module.exports = __webpack_public_path__ + "static/media/bg.026cf2f6.jpg";